import React from 'react';
import ReactDOM from 'react-dom';
import { GlobalStyle, SAUX360Theme } from '@saux/design-system-react';
import { ThemeProvider } from 'styled-components';
import * as serviceWorker from './serviceWorker';
import Documents from './Documents';

declare global {
  interface Window {
    renderDocuments: Function;
    unmountCreatereactapp: Function;
  }
}

window.renderDocuments = (containerId: string, session: any) => {
  ReactDOM.render(
    <ThemeProvider theme={SAUX360Theme}>
      <GlobalStyle />
      <Documents session={session} />
    </ThemeProvider>,
    document.getElementById(containerId),
  );
  serviceWorker.unregister();
};

// window.unmountCreatereactapp = (containerId: string) => {
//   containerId ? ReactDOM.unmountComponentAtNode(document.getElementById(containerId)) : '';
// };

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
